import { MutableRefObject } from 'react';

export function stashPreviousElement(
  previousActiveElementRef: MutableRefObject<HTMLElement | null>,
) {
  const activeElement = document.activeElement;
  previousActiveElementRef.current = activeElement instanceof HTMLElement ? activeElement : null;
}

export function restorePreviousElement(
  previousActiveElementRef: MutableRefObject<HTMLElement | null>,
) {
  const previousActiveElement = previousActiveElementRef.current;
  previousActiveElementRef.current = null;

  if (!previousActiveElement?.isConnected) {
    return;
  }

  // If the user has scrolled the previous active element out of view while the
  // menu was open, we don't want to scroll it back into view on close.
  requestAnimationFrame(() => previousActiveElement.focus({ preventScroll: true }));
}
